import { createFileRoute } from '@tanstack/react-router';
import { FAQ } from '@/features/consumer/faq';

export const Route = createFileRoute('/(consumer)/_public/faq')({
  component: FAQ,
});
